export default {
    halloween: ({app}) => app.wallet.halloween,
    loaded: ({app}) => app.loaded,
    user: ({app}) => app.user,
    wallet: ({app}) => app.wallet,
    bitcoin: ({app}) => app.bitcoin,
    clouds: ({app}) => app.clouds,
    cashapp_recipient: ({app}) => app.cashapp_recipient,
    chime_recipient: ({app}) => app.chime_recipient,
    square_order: ({app}) => app.square_order,
    payou_order: ({app}) => app.payou_order,
    cashapp_merchant_order: ({app}) => app.cashapp_merchant_order,
    cashapp: ({app}) => app.cashapp,
    cashapp_order: ({app}) => app.cashapp_order,
    chime_order: ({app}) => app.chime_order,
    cashapp_cashout: ({app}) => app.cashapp_cashout,
    paypal_links: ({app}) => app.paypal_links,
    paypal_order: ({app}) => app.paypal_order,
    modal_tx: ({app}) => app.modal_tx,
    modal_qr: ({app}) => app.modal_qr,
    modal_alert: ({app}) => app.modal_alert,
    modal_halloween: ({app}) => app.modal_halloween,
    modal_halloween_data: ({app}) => app.modal_halloween_data,
    bitcoin_profit: ({app}) => app.bitcoin_profit,
    bitcoin_cashout: ({app}) => app.bitcoin_cashout,
    tasks: ({app}) => app.tasks,
    buttons: {
        verification: ({app}) => app.buttons.verification,
        create_bitcoin_cashout: ({app}) => app.buttons.create_bitcoin_cashout,
        create_payou_order: ({app}) => app.buttons.create_payou_order,
        create_cashapp_merchant_order: ({app}) => app.buttons.create_cashapp_merchant_order,
        confirm_bitcoin_cashout: ({app}) => app.buttons.confirm_bitcoin_cashout,
        create_square_order: ({app}) => app.buttons.create_square_order,

        chime_create_button: ({app}) => app.buttons.chime_create_button,
        cashapp_create_button: ({app}) => app.buttons.cashapp_create_button,
        create_cashapp_cashout: ({app}) => app.buttons.create_cashapp_cashout,
        confirm_cashapp_cashout: ({app}) => app.buttons.confirm_cashapp_cashout,
        cancel_cashout: ({app}) => app.buttons.cancel_cashout,
        claim_cashback: ({app}) => app.buttons.claim_cashback,
        halloween: ({app}) => app.buttons.halloween
    }
}